import * as R from 'ramda'
import { isEmptyOrNil } from 'libs/empty'
import Assets from 'app/configs/assetConfigs'
export const getDisplayName = (root) => {
  const firstName = R.prop('firstName')(root)
  const lastName = R.prop('lastName')(root)
  const email = R.prop('email')(root)
  if (!isEmptyOrNil(firstName) || !isEmptyOrNil(lastName))
    return R.join(' ', [firstName, lastName])
  if (!isEmptyOrNil(email)) return email
  return '-'
}
export const getUserAvatar = R.compose(
  R.defaultTo(Assets.personSilhouetteImage),
  R.prop('avatar'),
)
